import { Component, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { IonModal, MenuController, Platform, ToastController } from '@ionic/angular';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { APIService } from 'src/providers/apiservices/apiservices';
import { GlobalService } from 'src/providers/apiservices/globalservices';
import { LocalStorageProvider } from 'src/providers/apiservices/localstorageprovider';
import { ConfigProvider } from 'src/providers/config/config';
import { UserConfigDto } from 'src/providersdata/UserConfigDto';

import {
  ActionPerformed,
  PushNotificationSchema,
  PushNotifications,
  Token,
} from '@capacitor/push-notifications';
import { NotificacoesProvider } from 'src/providers/notificacoes/notificacoes';

import { Events } from 'src/providers/apiservices/eventsservice';
import { register } from 'swiper/element/bundle';
register();


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  @ViewChild(IonModal) modal: IonModal;

  isModalOpen = false;
  public appMenu=[];
  public appMenuFilters = [
    { title: 'Início', url: '/home', icon: 'file-tray-full-outline', count: 0, idModulo: 1 , idAtividade: null, showSubmenu: null, submenu:null},
    { title: 'Comunicação', url: '/comunicacao', icon: 'chatbox-outline', count: 0 , idModulo: 6, idAtividade: null, showSubmenu: null, submenu:null},
    { title: 'Autorização de serviço', url: '/autorizacao', icon: 'id-card-outline', count: 0 , idModulo: 8 , idAtividade: null, showSubmenu: null, submenu:null},
    { title: 'Informe de vendas', url: '/informe', icon: 'bar-chart-outline', count: 0, idModulo: 2, idAtividade: null, showSubmenu: null, submenu:null},
    { title: 'Financeiro', url: '/cobranca', icon: 'card-outline', count: 0, idModulo: 5, idAtividade: null, showSubmenu: null, submenu:null  },
    { title: 'Encomendas', url: '/config/encomendas', icon: 'cube-outline', count: "NOVO", idModulo: 12, idAtividade: null, showSubmenu: null, submenu:null },
    { title: 'Multi', url: '/dashboard-multi', img: './assets/img/multi.png', count: 0, idModulo: 10, idAtividade: null, showSubmenu: null, submenu:null },
    { title: 'Conheça Seus Clientes', url: '/dashboard-multi', icon: 'grid-outline', count: 0, idModulo: 10, idAtividade: '1', showSubmenu: null, submenu:null },
    { title: 'Ofereça um Benefício', url: '/formbeneficios/listagem', icon: 'reader-outline', count: 0, idModulo: 10, idAtividade: '2', showSubmenu: null, submenu:null }
  ];


  public appPages = [];
  public appMenuPages = [
    { title: 'Shoppings', url: '/shoppings', icon: 'storefront-outline', count: 0, idModulo:4 },
    { title: 'Usuários', url: '/usuarios', icon: 'people-circle-outline', count: 0, idModulo:3 },
    { title: 'IA Comunicação', url: '/iacomunicacao', path: 'iacomunicacao', icon: 'sparkles-outline', count: 0, idModulo: 6, idAtividade: '3' },
    { title: 'Biblioteca', url: '/biblioteca', icon: 'library-outline', count: 0, idModulo:7  },
    // TODO: Andre - CONTROLE CIENCIA - DES MODAL - verificar se o controle ciência vem daqui - voltar depois
    // { title: 'Auditoria', url: '/auditoria', icon: 'shield-outline', count: 'NOVO', idModulo: 1, idAtividade: "3,4" }

  ];


  nomeUsuario;
  emailUsuario;
  avatarUsuario='';
  configUser: UserConfigDto = new UserConfigDto(null);
  idTipoUsuario = 2;



  constructor(
    private menuCtrl: MenuController,
    private router: Router,
    private platform: Platform,
    private globalService: GlobalService,
    private toastCtrl: ToastController,
    private configProvider:ConfigProvider,
    private providerLocalStorage: LocalStorageProvider,
    private notificacaoProvider: NotificacoesProvider,
    private events: Events
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(async () => {
      this.menuCtrl.enable(false);
      await this.getConfig();
      // Chamadas extras
      

    });
  }

  async getBanners(){
    var me=this;

    this.configProvider.getBanners().then(
      response => {
        var temp=[];
        temp.push(response);
        APIService.BANNERS=temp[0];
        
      }
    );
  }


  async getConfig(){
    var me=this;

    this.configProvider.getConfig().then(
      async response => {
        var temp=[];
        temp.push(response);

        if (APIService.gAppInsights){
        }
        else{
          APIService.gAppInsights = new ApplicationInsights({ config: {
            instrumentationKey: temp[0].INSIGHTS
            /* ...Other Configuration Options... */
          } });
          APIService.gAppInsights.loadAppInsights();

        }

        APIService.API_URL=temp[0].API_URL;
        APIService.API_KEY=temp[0].API_KEY;
        APIService.NOTIF_URI=temp[0].NOTIF_URI;

        APIService.storage_key=temp[0].STORAGE_KEY;
        APIService.storage_notificacao=temp[0].STORAGE_NOTIFICACAO;

        APIService.AMBIENTE=temp[0].AMBIENTE;
        APIService.CHAT_URL=temp[0].CHAT_URL;

        APIService.GRUPO_VIDEOLIB=temp[0].GRUPO_VIDEOLIB;

        // PUSHER
        APIService.PUSHER_KEY=temp[0].PUSHER_KEY;
        APIService.PUSHER_AMBIENTE=temp[0].PUSHER_AMBIENTE;
        APIService.PUSHER_CHANNEL=temp[0].PUSHER_CHANNEL;
        APIService.PUSHER_CLUSTER=temp[0].PUSHER_CLUSTER;

        APIService.MULTIPLAN_IMAGE_HOME = temp[0].MULTIPLAN_IMAGE_HOME;
        APIService.MULTIPLAN_URL_HOME = temp[0].MULTIPLAN_URL_HOME;
        APIService.MULTIPLAN_IMAGE_LOGIN = temp[0].MULTIPLAN_IMAGE_LOGIN;
        APIService.MULTIPLAN_IMAGE_SENHA = temp[0].MULTIPLAN_IMAGE_SENHA;
        APIService.MULTIPLAN_IMAGE_NEW = temp[0].MULTIPLAN_IMAGE_NEW;
        APIService.APPID = temp[0].APPID;
        APIService.TENANT = temp[0].TENANT;
        APIService.PACKAGE_NAME = temp[0].PACKAGE_NAME;
        APIService.HASH_ANDROID = temp[0].HASH_ANDROID;

        //APIService.storage_key_cheguei=temp[0].StorageKeyCheguei;
        APIService.versao= temp[0].VERSAO;

        APIService.NOVO_BANNER= temp[0].NOVO_BANNER;

        // if (APIService.NOVO_BANNER=="S"){
        //   await this.getBanners();
        // }
        //this.verificacaoBiometrica();
        this.router.events.subscribe((event: RouterEvent) => {
          if (event instanceof NavigationEnd && event.url === '/login') {
            this.menuCtrl.enable(false);
          }
        });
        if (this.platform.is("capacitor")) {

          this.installPush();

        }


      }
    );
  }


  globalSubscribe() {

    this.globalService.getObservable().subscribe((data) => {
      if (data.tipo=="Toast")
      {
        this.presentToast(data.item.Mensagem,data.item.Severidade,data.item.Posicao);

      }
      else if (data.tipo=="CarregaMenu")
      {
        this.carregMenuEvent();
      }


    });

  }

  ngOnInit() {
    // this.router.events.subscribe((event: RouterEvent) => {
    //   if (event instanceof NavigationEnd && event.url === '/login') {
    //     this.menuCtrl.enable(false);
    //   }
    // });

    this.globalSubscribe();

    this.events.subscribe('app.refreshData', (_) => {
      this.configUser = this.providerLocalStorage.getUserConfig(APIService.UsuarioLogado.Usuario.login1);
    });

  }

  ngAfterViewInit()
  {
    this.menuCtrl.enable(true);
  }

  dismiss() {
    this.isModalOpen = false;
    this.modal.dismiss();
  }

  onClick(){

  }

  setDashboardEntradaToMenu(title: string) {
    if(title === 'Conheça Seus Clientes') {
      APIService.entradaDashboard = APIService.ENTRADA_MENU;
    }
  }

  /** EVENTOS */

  async presentToast(mensagem, tipo, posicao) {
    var cortoast="primary";
    // Warning
    if (tipo==0){
      var cortoast="success";
    }
    else if (tipo==1){
      var cortoast="secondary";
    }
    else if (tipo==2){
      var cortoast="danger";
    }

    var lposicao = 'top';
    if (posicao){
      lposicao=posicao;
    }
    const toast = await this.toastCtrl.create({
      message: mensagem,
      duration: 20000,
      position: lposicao=='top'?'top':'bottom',
      color:cortoast,
      buttons: [
        {
          side: 'end',
          //icon: 'star',
          role: 'cancel',
          text: 'Fechar',
          handler: () => {

          }
        }
      ]
    });
    toast.present();
  }

  abrirModalEmpresaContrato()
  {
    this.globalService.createModalEmpresaContrato()
    .then(modal => {
      modal?.onDidDismiss().then(ret => {
          this.carregMenuEvent();
      })

      modal?.present();
    })
  }

  validarMenuOLD(modulosAtividadeVisao, menu) {
    if (!menu.idAtividade) {
      return !!modulosAtividadeVisao[menu.idModulo]
    }

    return !!modulosAtividadeVisao[menu.idModulo] && (Array.isArray(modulosAtividadeVisao[menu.idModulo]?.ids) ? modulosAtividadeVisao[menu.idModulo].ids.includes(menu.idAtividade) : false);
  }
  validarMenu(modulosAtividadeVisao, menu) {
    if (!menu.idAtividade) {
      return !!modulosAtividadeVisao[menu.idModulo]
    }

    return !!modulosAtividadeVisao[menu.idModulo] && (Array.isArray(modulosAtividadeVisao[menu.idModulo]?.ids) ? modulosAtividadeVisao[menu.idModulo].ids.some(userId => String(menu.idAtividade).split(',').includes(String(userId))) : false);
  }

  showForce = false;
  menuItemForce(): void {
    this.showForce = !this.showForce;
  }
  processModule(element: any, sourceArray: any[], targetArray: any[]) {
    const item = sourceArray.find(x => {
      if(Array.isArray(x.submenu))
      {
        x.submenu = x.submenu.filter(y => APIService.VisaoGeralUsuario.find(z => String(y.idAtividade).split(',').includes(String(z.idAtividade)) && z.idModulo == y.idModulo))
      }

      return x.idModulo === element.idModulo;
    });
    if (item && !targetArray.some(x => x.idModulo === element.idModulo)) {
      targetArray.push(item);
    }
  }
  async carregMenuEvent(){

    this.appMenu = [];
    this.appPages = [];

    var usu=this.providerLocalStorage.loggedUser.Usuario;

    this.idTipoUsuario = usu.idTipoUsuario;

    this.nomeUsuario=usu.nomUsuario;
    this.emailUsuario=usu.login1;

    this.configUser = this.providerLocalStorage.getUserConfig(usu.login1 + "");
    this.configUser.token = APIService.UsuarioLogado.TOKENJWT;
    this.configUser.dataToken = APIService.UsuarioLogado.dataToken;

    if(this.configUser.usuario == '') {
      this.configUser.usuario = usu.login1.trim();

      this.providerLocalStorage.saveUserConfig(this.configUser);
    }

    this.configUser = this.providerLocalStorage.getUserConfig(usu.login1 + "");

    if(this.configUser.usuario == '') {
      this.carregMenuEvent();
      return;
    }

    if(!this.configUser.nomeUsuario)
      this.configUser.nomeUsuario = usu.nomUsuario;

    this.avatarUsuario = this.configUser.getIniciais();

    var visao = this.geraVisaoModulos(usu.contratoLoginPerfils);
    APIService.VisaoGeralUsuario = visao;
    APIService.VisaoUsuario=visao;

    //const modulosVisao: number[] = [...new Set(APIService.VisaoUsuario.map(x => x.idModulo))];
    const modulosAtividadeVisao = [];

    APIService.VisaoUsuario.forEach(visaoUsuario => {
      if(modulosAtividadeVisao[visaoUsuario.idModulo])
      {
        modulosAtividadeVisao[visaoUsuario.idModulo].ids.push(visaoUsuario.idAtividade);
        return;
      }

      modulosAtividadeVisao[visaoUsuario.idModulo] = {ids: [visaoUsuario.idAtividade]};
    })

    var temp=[];
    this.appMenuFilters.forEach(element => {
      var incluido=false;
      visao.forEach(element2 => {
        // verificar se o menu é o módulo da visão
        if (element.idModulo==element2.idModulo ){
          // se for, verificar se a opção tem ativiade
          if (element.idAtividade){
            if (String(element.idAtividade).split(',').includes(String(element2.idAtividade))){
              if (!incluido){
                temp.push(element);
                incluido=true;
                //verifica submenus
                if (element.showSubmenu==true){
                  var submenu = [];
                  submenu.push(element.submenu);
                  temp[temp.length-1].submenu=[];
                  submenu[0].forEach(sub => {
                    var incluidoSub=false;
                    visao.forEach(elementSub => {
                      if (sub.idModulo==elementSub.idModulo && String(sub.idAtividade).split(',').includes(String(elementSub.idAtividade)) && !incluidoSub ){
                        incluidoSub=true;
                        temp[temp.length-1].submenu.push(sub);
                      }

                    });
                  });
                }
              }
            }
          }
          else{
            if (!incluido){
              temp.push(element);
              incluido=true;
              //verifica submenus
              if (element.showSubmenu==true){
                var submenu = [];
                submenu.push(element.submenu);
                temp[temp.length-1].submenu=[];
                submenu[0].forEach(sub => {
                  var incluidoSub=false;
                  visao.forEach(elementSub => {
                    if (sub.idModulo==elementSub.idModulo && String(sub.idAtividade).split(',').includes(String(elementSub.idAtividade)) && !incluidoSub ){
                      incluidoSub=true;
                      temp[temp.length-1].submenu.push(sub);
                    }

                  });
                });
              }
            }
          }
        }        
      });
    });
    //this.appMenu = this.appMenuFilters.filter(menu => this.validarMenu(modulosAtividadeVisao, menu));
    this.appMenu = temp;

    this.appPages = this.appMenuPages.filter(menu => this.validarMenu(modulosAtividadeVisao, menu));

    // console.log("AppMenu", this.appMenu);

    // console.log("AppMenuPages", this.appMenuPages)

    // Verificar se o usuário é lojista ou ADM
    if (usu.idTipoUsuario==1){
      if(this.configUser.shoppingCod == '') {
        this.providerLocalStorage.saveUserConfig(this.configUser);

      }

    }
    else{
      // Pega os dados dso shopping e da loja e grava
      // não abre o modal
      this.configUser.numContrato=usu.contratoLoginPerfils[0].contrato.numContrato;
      this.configUser.loja=usu.contratoLoginPerfils[0].contrato.nomContrato;
      this.configUser.shoppingCod=usu.contratoLoginPerfils[0].empresa.idEmpresa;
      this.configUser.shoppingTexto=usu.contratoLoginPerfils[0].empresa.nomEmpresa;
      this.configUser.tipoUsuario = usu.idTipoUsuario;
      this.providerLocalStorage.saveUserConfig(this.configUser);

    }

    // Registrar Dispositvo
    this.registrarDispositivo();

    if (APIService.NOVO_BANNER=="S"){
      await this.getBanners();
    }



  }
  geraVisaoModulos(listaContratos){
    var listaVisao=[];
    listaContratos.forEach(element => {
      var perfil = element.idPerfilNavigation;
      perfil.ids.forEach(element1 => {
        var data={
          "idModulo":element1.idModulo,
          "idAtividade":element1.idAtividade,
          "desAtividade":element1.desAtividade,
          "desModulo":element1.id.desModulo,

        };
        listaVisao.push(data);

      });


    });
    return listaVisao;
  }

  /** NOTIFICACAO */
  listaNotificacoes=[];
  mNovas=0;


  installPush() {

    //console.log("INSTALL PUSH");

    PushNotifications.requestPermissions().then((result) => {
      ////console.log("PERMISSÃO " + result.receive);
      if (result.receive === 'granted') {
          //console.log("REQUEST PERMISSION");

         PushNotifications.register();
       } else {
         // Show some error
       }
    });

    PushNotifications.addListener('registrationError', err => {
      console.error('Registration error: ', err.error);
    });


    PushNotifications.addListener('registration', (token: Token) => {
      // Push Notifications registered successfully.
      // Send token details to API to keep in DB.
      //console.log("REGISTRANDO DEVICE");
      this.setRegistration(token.value);
    });

    PushNotifications.addListener(
      'pushNotificationReceived',
      (notification: PushNotificationSchema) => {
        // Show the notification payload if the app is open on the device.
      }
    );

    PushNotifications.addListener(
      'pushNotificationActionPerformed',
      (notification: ActionPerformed) => {
        // Implement the needed action to take when user tap on a notification.
      }
    );
  }

    setRegistration(registration: any) {
    // Registra o device
    //console.log('The token is ' + registration);
    APIService.NOTIF_deviceToken = registration;
  }


  registrarDispositivo(){
     if (this.platform.is("android") || this.platform.is("ios")){
       if (APIService.NOTIF_deviceToken){
        this.notificacaoProvider.registrarPostFirebase(APIService.NOTIF_deviceToken,APIService.UsuarioLogado.Usuario.login1).then(
          response => {
             var temp=[];
              temp.push(response);
              if (temp[0].item)
              {
                // Marca o paciente
//                APIService.NOTIF_idHub=temp[0].item;
 //               this.registrarUsuario();
              }
          }).catch((error: any) => {
            this.globalService.publishToast({ Mensagem: error.erro || "Ocorreu um erro em sua solicitação. Por favor, tente novamente", Severidade: 2, Posicao: "top" });
          });

       }

     }
   }

   registrarUsuario_NAOUSADO(){
      var me=this;
      var plataforma="";
      if (this.platform.is("android")){
        plataforma="gcm";
      }
      else if (this.platform.is("ios")){
        plataforma="apns";
      }
      else{
        plataforma="gcm";
      }
      this.notificacaoProvider.registrarPut(APIService.NOTIF_idHub,plataforma, APIService.UsuarioLogado.Usuario.login1, APIService.NOTIF_deviceToken).then(
        response => {
           var temp=[];
            //console.log(response);
            temp.push(response);

            if (temp[0].item)
            {
              // Marca o paciente
              if (temp[0].item==false) {
                this.globalService.publishToast({ Mensagem: "Problema no cadastro do usuário na notificacão.", Severidade: 2, Posicao: "top" });
              }


            }
            else{
              //alert (temp[0].erro);
              this.globalService.publishToast({ Mensagem: temp[0].erro, Severidade: 2, Posicao: "top" });
            }

        })
        .catch((error: any) => {
          //console.log(error);
          this.globalService.publishToast({ Mensagem: error.erro || "Ocorreu um erro em sua solicitação. Por favor, tente novamente", Severidade: 2, Posicao: "top" });
      });


   }




}
